import { useEffect } from 'react';
import { useQuery } from 'react-apollo';
import { queries } from '@kiper/account-graphql/auth';
import { MFA_STEP_KEYS } from '../steps';

/**
 * Redireciona para o app quando o `whoAmI` está em cache (exceto nos steps de MFA).
 */
export default function useWhoAmIRedirect({
  currentStep,
  redirectUri,
  history,
}) {
  const { data: whoImData } = useQuery(queries.whoAmI, {
    fetchPolicy: 'cache-only',
  });

  useEffect(() => {
    if (whoImData && !MFA_STEP_KEYS.includes(currentStep.key)) {
      const { whoAmI } = whoImData;
      history.push({
        pathname: 'products',
        state: {
          ...whoAmI,
          redirectUri,
        },
      });
    }
  }, [whoImData]);
}
